<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Rozrachunki</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Strona:</label>
        <multiselect-input v-model="form.side" :options="sides" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        <label class="pt-4 block text-gray-700">Typ:</label>
        <multiselect-input v-model="form.type" :options="types" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
        <label class="pt-4 block text-gray-700">Rozliczenie:</label>
        <multiselect-input v-model="form.settlement" :options="settlement_opts" class="mt-1 w-full" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" />
      </search-filter>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-6 pb-4">Płatnik</th>
          <th class="px-3 pt-6 pb-4">Strona</th>
          <th class="px-3 pt-6 pb-4">Numer</th>
          <th class="px-3 pt-6 pb-4">Symbol</th>
          <th class="px-3 pt-3 pb-2">Data<br>wystawienia</th>
          <th class="px-3 pt-3 pb-2">Wartość<br>brutto</th>
          <th class="px-3 pt-3 pb-2">Termin<br>płatności</th>
          <th class="px-3 pt-3 pb-2">Razem<br>zapłacono</th>
          <th class="px-3 pt-6 pb-4">Pozostało</th>
          <th class="px-3 pt-6 pb-4">Uwagi</th>
          <th class="px-3 pt-6 pb-4">Opis</th>
        </tr>
        <tr v-for="settlement in settlements.data" :key="settlement.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':settlement.rozliczony == 0, 'bg-orange-50':settlement.rozliczony == 1}">
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ settlement.kontrahent }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ settlement.strona }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ settlement.numer }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ settlement.symbol }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ settlement.data }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-end focus:text-shtax-500">
              {{ settlement.brutto }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ settlement.termin }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ settlement.razem }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ settlement.pozostalo }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ settlement.uwagi }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ settlement.opis }}
            </span>
          </td>
        </tr>
        <tr v-if="settlements.data.length === 0">
          <td class="border-t px-3 py-2" colspan="11">Nie znaleziono rozrachunków.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="settlements.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Rozrachunki' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    MultiselectInput
  },
  layout: Layout,
  props: {
    filters: Object,
    settlements: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        type: this.filters.type,
        side: this.filters.side,
        settlement: this.filters.settlement
      },
      sides: [{id:'WN',name:'WN'}, {id:'MA',name:'MA'}],
      types: [{id:'h',name:'Dokument handlowy'}, {id:'f',name:'Dokument finansowy'}],
      settlement_opts: [
        {'id': 0, 'name': 'Nie rozliczone' },
        {'id': 1, 'name': 'Rozliczone częściowo' },
        {'id': 2, 'name': 'Rozliczone całkowicie' }
      ]
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('settlements'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  }
}
</script>
